import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

/**
 * Sticky banner shown to any authenticated user (hotel, dispatch, driver,
 * admin) when an event surge is active. Provides full-app visibility on
 * why current fares are higher (or lower) than usual.
 */
export default function EventSurgeBanner() {
  const [surge, setSurge] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await api.get("/event-surge");
        if (!cancelled) setSurge(res.data || null);
      } catch (e) {
        // silent — banner just doesn't render
        if (!cancelled) setSurge(null);
      }
    };
    load();
    const id = setInterval(load, 60_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!surge?.active) return null;

  const pct = Number(surge.default_pct || 0);
  const sign = pct >= 0 ? "+" : "";
  const positive = pct >= 0;

  return (
    <div
      className={
        "flex items-center justify-center gap-2 border-b px-4 py-2 text-xs font-medium " +
        (positive
          ? "border-primary/30 bg-primary/10 text-primary"
          : "border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400")
      }
      data-testid="event-surge-banner"
    >
      <Sparkles className="h-3.5 w-3.5" />
      <span>
        <strong>{surge.label || "Événement"}</strong> · tarifs ajustés{" "}
        <strong>
          {sign}
          {pct}%
        </strong>
      </span>
    </div>
  );
}
